var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "about-layout__credit_form" }, [
    _c("form", { staticClass: "form-default" }, [
      _c(
        "div",
        { staticClass: "fields" },
        [
          _c("no-ui-slider", {
            ref: "payment",
            attrs: {
              title: "Ежемесячный платёж",
              min: _vm.payment.min,
              max: _vm.payment.max,
              step: _vm.payment.step,
              start: _vm.payment.start,
              postfix: "руб",
              view: _vm._f("threeDigits")(_vm.payment.value)
            },
            model: {
              value: _vm.payment.value,
              callback: function($$v) {
                _vm.$set(_vm.payment, "value", $$v)
              },
              expression: "payment.value"
            }
          }),
          _vm._v(" "),
          _c("no-ui-slider", {
            ref: "deposit",
            attrs: {
              title: "Первоначальный взнос",
              min: _vm.deposit.min,
              max: _vm.deposit.max,
              step: _vm.deposit.step,
              start: _vm.deposit.start,
              postfix: "руб",
              view: _vm._f("threeDigits")(_vm.deposit.value)
            },
            model: {
              value: _vm.deposit.value,
              callback: function($$v) {
                _vm.$set(_vm.deposit, "value", $$v)
              },
              expression: "deposit.value"
            }
          }),
          _vm._v(" "),
          _c("label", { staticClass: "input-container" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isFamily,
                  expression: "isFamily"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.isFamily)
                  ? _vm._i(_vm.isFamily, null) > -1
                  : _vm.isFamily
              },
              on: {
                change: function($event) {
                  var $$a = _vm.isFamily,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isFamily = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isFamily = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isFamily = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "input-container__label" },
              [
                _c("span", [
                  _vm._v("Семейная ипотека с государственной поддержкой")
                ]),
                _vm._v(" "),
                _vm._t("family-link")
              ],
              2
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bottom" },
        [
          _c("p", [_vm._v("Вы можете рассчитывать на:")]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [
            _c("small", [_vm._v("Общая сумма")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("threeDigits")(_vm.result)) + " "),
              _c("i", { staticClass: "ruble" })
            ])
          ]),
          _vm._v(" "),
          _vm._t("button", [
            _c(
              "button",
              {
                staticClass: "button-pill filled",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toCatalog()
                  }
                }
              },
              [_vm._v("Подобрать квартиру")]
            )
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }